export const extendFuseOptions = (keys: string[]) => {
  return {
    threshold: 0.2,
    maxPatternLength: 32,
    keys,
  }
}
